/** Copy HU 8209 — Ofertas de crédito. Ticks = HU (capturas Ofertas_* son data demo). */
export const PERFIL_OFERTAS_COPY = {
  titulo: 'Ofertas de crédito',
  introUna:
    'Tienes 1 oferta de crédito. Revisa, compara y selecciona la mejor opción de crédito para tu negocio.',
  introVarias: (x: number) =>
    `Tienes ${x} ofertas de crédito. Revisa, compara y selecciona la mejor opción de crédito para tu negocio.`,
  introCero: 'No hay ofertas para esta solicitud',
  vacioFiltro: 'No hay ofertas con esos filtros. Prueba otro monto o tasa, o muestra todas.',
  errorCarga: 'No pudimos cargar las ofertas. Intenta de nuevo.',
  atrasAria: 'Volver a tus solicitudes',
  filtroMonto: 'Monto pre-aprobado:',
  filtroTasa: 'Tasa de interés:',
  mostrarTodas: 'Mostrar todas las ofertas',
  ordenarPor: 'Ordenar por',
  ordenMayorMonto: 'Mayor monto',
  ordenMenorTasa: 'Menor tasa',
  ordenMayorPlazo: 'Mayor plazo',
  comparar: 'Comparar',
  compararTitulo: 'Comparar ofertas',
  compararEmpty: 'Selecciona al menos 2 ofertas de crédito para poder compararlas',
  tomarOferta: 'Tomar oferta',
  rechazarOfertas: 'Rechazar ofertas',
  siTomarOferta: 'Si, tomar oferta',
  revisarOfertas: 'Revisar ofertas',
  salir: 'Salir',
  modalSalirTitulo: 'Ten en cuenta...',
  modalSalirAntes: (x: number) =>
    `Si no tomas alguna de las ofertas durante los próximos ${x} días, es probable que `,
  modalSalirEnfasis: 'algunos valores de la oferta cambien',
  modalSalirDespues: ', o que los Aliados Financieros retiren su oferta.',
  compararIconAria: 'Comparar ofertas',
  compararFab: (n: number) => `Comparar (${n})`,
  pagaloEn: (n: number) => `Págalo en ${n} meses`,
  montoAprobado: 'Monto aprobado',
  compararMonto: 'Monto',
  plazo: 'Plazo',
  plazoMeses: (n: number) => `${n} meses`,
  garantias: 'Garantías',
  pago: 'Pago',
  desembolso: 'Desembolso',
  desembolsoNeto: 'Desembolso neto',
  cuotaAproxMensual: 'Cuota aprox. mensual',
  filaTomarMonto: 'Monto aprobado:',
  filaTomarGarantias: 'Garantías:',
  filaTomarDesembolso: 'Desembolso neto:',
  filaTomarTasa: 'Tasa:',
  filaTomarCuota: 'Cuota aprox. mensual',
  filaTomarPlazo: 'Plazo:',
  observaciones: 'Observaciones',
  tasa: 'Tasa',
  tasaEa: (n: number) => `${formatTasaLabel(n)} E.A.`,
  cuotaAprox: 'Cuota aprox.',
  unResultado: '1 resultado',
  nResultados: (n: number) => `${n} resultados`,
  ticksMontoMillones: [25, 50, 75, 100, 125, 150, 175, 200] as const,
  ticksTasaPorcentaje: [10, 20, 30, 40, 50, 60] as const,
  tickMontoSinTecho: '+200M',
  tickTasaSinTecho: '+60%',
  creditoBancoldex: 'Crédito Bancóldex',
  creditoBancoldexL1: 'Crédito',
  creditoBancoldexL2: 'Bancóldex',
  ofertaDineroBancoldex: 'Oferta con dinero Bancóldex',
  badgeBancoldexAria: 'Qué es un crédito Bancóldex',
  lineaBancoldex: 'Línea Bancóldex',
  quitarCompararAria: 'Quitar de la comparación',
  seleccionarAria: 'Seleccionar para comparar',
  modalGarantiasTitulo: 'Garantías',
  modalGarantiasIntro:
    'Corresponden a los seguros que hacen posible tu crédito sin pedirte hipotecas o codeudores. Para esta oferta de crédito, las garantías son:',
  modalGarantiasDescuento: (total: number, monto: number) =>
    `-${formatDineroCop(total)} se descontarán del monto aprobado (${formatDineroCop(monto)}).`,
  concepto: 'Concepto',
  tipoPago: 'Tipo de pago',
  valor: 'Valor',
  aceptar: 'Aceptar',
  modalTomarTitulo: '¿Deseas tomar esta oferta de crédito?',
  modalTomarLeadAntes: 'Estás a punto de tomar el crédito de ',
  modalTomarLeadDespues: ':',
  modalTomar2Titulo: 'Ten en cuenta...',
  modalRechazarTitulo: 'Rechazar ofertas',
  modalRechazarHint: 'Selecciona el motivo por el que no tomarás ninguna oferta.',
  motivoPlaceholder: 'Selecciona un motivo',
  modalRechazarOtro: 'Cuéntanos el motivo',
  modalRechazarCondiciones: 'Condiciones que no te convienen',
  cancelar: 'Cancelar',
  totalGarantias: 'Total Garantías',
  par078Fallback:
    'Confirmo que he leído y entendido las condiciones de la oferta, incluyendo las garantías solicitadas por el Aliado Financiero.',
  par079Fallback:
    'Ten en cuenta que el Aliado Financiero puede solicitar información adicional durante el proceso de formalización del crédito.',
  docsSegmentoTitulo: 'Archivos adicionales',
  docsSegmentoHint:
    'Para formalizar esta oferta, el Aliado Financiero solicita estos documentos. Carga los obligatorios (*) antes de continuar.',
  docsSegmentoAuth:
    'Para la formalización del crédito con el Aliado Financiero será necesario realizar la Autorización de Uso de Datos de Bancóldex.',
  docsSegmentoAuthLink: 'Abrir autorización',
  docsSegmentoAuthUrl: 'https://vinculacion.bancoldex.com/datospersonales/#/',
  docsSegmentoCargar: 'Cargar archivo',
  docsSegmentoVer: 'Ver archivo',
  docsSegmentoQuitar: 'Quitar archivo',
  docsSegmentoOpcional: '(Opcional)',
  docsSegmentoCargado: 'Archivo cargado',
  docsSegmentoCheck: 'He revisado / cargado los documentos obligatorios',
  docsSegmentoDescargarGuia: 'Descargar guía',
  revisarOfertasCta: 'Revisar ofertas',
  homeRevisarOfertas: 'Revisar ofertas',
  homeRevisarUna: 'Revisar 1 oferta',
  homeRevisarN: (n: number) => `Revisar ${n} ofertas`,
};

export function formatTasaLabel(tasa: number): string {
  return `${tasa}%`;
}

export function formatMontoMillones(monto: number): string {
  const millones = monto / 1_000_000;
  if (millones >= 200) {
    return '+200M';
  }
  const redondeado = Math.round(millones);
  return `${redondeado}M`;
}

export function formatDineroCop(valor: number): string {
  const abs = Math.round(Math.abs(valor)).toLocaleString('es-CO');
  return valor < 0 ? `- $${abs}` : `$${abs}`;
}

export function perfilOfertasIntro(cantidad: number): string {
  if (cantidad <= 0) {
    return PERFIL_OFERTAS_COPY.introCero;
  }
  if (cantidad === 1) {
    return PERFIL_OFERTAS_COPY.introUna;
  }
  return PERFIL_OFERTAS_COPY.introVarias(cantidad);
}
